/**
 * Comedien.ch Frontend application
 */

// Layout UI/UX
require('./misc/layout');

// Clip path support for Firefox
var FrontClipPathSupport = require('./misc/clipPathSupport');
var clipPath = new FrontClipPathSupport(80);
clipPath.init();

// Helpers
require('./misc/helpers');

// Search
require('./misc/search');

// Actors
require('./actors/archive');
require('./actors/single');
require('./actors/singleManageMedias');

// Places
require('./places/archive');
require('./places/single');

// Events
require('./events/single');

// Classifieds
require('./classifieds/main');

// Dashboard
require('./dashboard/main');
require('./dashboard/formImages');
require('./dashboard/settings');
require('./dashboard/home');
require('./dashboard/places/form');
require('./dashboard/places/index');
require('./dashboard/events/form');
require('./dashboard/events/index');
require('./dashboard/classifieds/form');
require('./dashboard/classifieds/index');
require('./dashboard/casting/form');
require('./dashboard/casting/index');
require('./dashboard/casting/view');

// FAQ
require('./faq/archive');
require('./faq/shortcode');

// Sign in / sign up
require('./signin/main');
var signup = require('./signup/main');

// Home
require('./home/main');

// Newsletter
require('./newsletter/main');

// Contact us
require('./contact/main');

// Misc.
require('./misc/widgetHeaderAlerts');
require('./misc/gdpr');

// Exposing our app as a standalone API

var ComedienApp = function() {};

ComedienApp.prototype = {
    signup: signup, // for reCaptcha
};

module.exports = new ComedienApp();
